import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from "react-to-print";
import { Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap';
import { formatDetailText, formatBettypeText, checkDateTimeText } from './SearchResult';
import { textFormatAmountFn } from '../../Common/GlobalFunc';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { useAdobeLaunch } from '../../Common/utils/adobeLaunch';

export const Export = ({ downloadData, offsetDate }) => {
    //console.log('downloadData', downloadData);
    const { t, i18n } = useTranslation();
    const globalContext = useContext(GlobalContext);
    const serverTime = globalContext?.sessionServerTimeStamp || (new Date()).getTime();
    const { sendAdobeEvent } = useAdobeLaunch()

    const downloadHTMLFunc = () => {
        const exportDate = new Date(serverTime)
            .toLocaleString('zh-HK', { hour12: false })
            .split('/')
            .map((i) => {
                if (i.length === 1) return '0' + i;
                return i;
            })
            .join('-');
        const dlDiv = document.getElementById('acPastDays');
        let dlHtml = `<!doctype html>
        <html>
        <head>
        <meta charset="utf-8">
        <title>${t('LB_BETSLIP_ACCOUNTRECORDS')} ${exportDate}</title>
        <style>
        .ARMain {width: 1000px;font-size: 13px;background-color: #e7e7e7;margin: 0px;cursor: default;}.ARMain .acInfo {width: 100%;background-color: #FFF7D5;height: 40px;line-height: 20px;font-weight: bold;}.ARMain .acInfo .acInfoCell {display: inline-block;width: 33.33%;}.ARMain .acInfo .acInfoCell .labelText {padding-left: 15px;padding-right: 12px;}.ARMain .acInfo .acInfoCell .colorBule {color: #003C84;}.ARMain .acInfo .borderLLine {border-left: 1px solid #333333;margin: 10px 0;height: 20px;}.ARMain .ARContent {position: relative;height: 100%;}.ARMain .ARContent .search-result-container {padding: 0 18px 48px;position: relative;}.ARMain .ARContent .search-result-container .acctstmt-header {display: flex;justify-content: space-between;align-items: center;height: 50px;font-weight: bold;border-bottom: 1px solid #B6B6B6;}.ARMain .ARContent .search-result-container .acctstmt-header .new-search-btn {display: none;}.ARMain .ARContent .search-result-container .acctstmt-header .header-r{display: none;}.ARMain .ARContent .search-result-container .ARResultTable {display: none;width: 100%;}.ARMain .ARContent .search-result-container .ARResultTable .table-row .table-cell {height: 36px;padding: 8px;vertical-align: top;background: #fff;}.ARMain .ARContent .search-result-container .ARResultTable .table-row .ar-detail {white-space: pre-wrap;}.ARMain .ARContent .search-result-container .ARResultTable .table-row .ar-receipt {display: none;}.ARMain .ARContent .search-result-container .ARResultTable .table-row.sec .table-cell {background: #f4f4f4;}.ARMain .ARContent .search-result-container .ARResultTable .table-header .table-cell {height: 36px;background-color: unset;vertical-align: middle;}.ARMain .ARContent .search-result-container .print-table {display: table;border-collapse: collapse;}.ARMain .ARContent .search-result-container .ARResultTableM {display: none;}.ARMain .ARContent .search-result-container .wait-mobile {display: none;}.ARMain .ARContent .search-result-container .ARPagination {display: none;}.ARMain .ARSearchBox-l {width: 42%;min-width: 290px;float: left;}.ARMain .ARSearchBox-r {border-left: #333333 1px solid;float: left;text-align: right;width: 58%;min-width: 290px;}.ARMain .speedbetStatementRange {padding: 0px 5px 0px 5px;margin: 0px 5px 0px 5px;}.ARMain .statementSelection_1st {margin: 0px;}.ARMain .statementSelection {margin: 15px 0px 0px 0px;}.ARMain .statementRadio {display: inline-flex;margin-right: 8px;}.ARMain .recordRange {font-size: 11px;padding: 8px 0px 0px 20px;}.ARMain .statementDropdown {float: right;}.ARMain .statementDropdown > .dropdown-toggle {width: 320px;margin-left: 10px;background-color: #FFFF;color: #000;border: #000 1px solid;box-shadow: none;text-align: left;}.ARMain .alignButton {float: right;margin-top: 10px;}.ARMain .hide {display: none;}.ARMain .selectionLabel {line-height: 31px;}.ARMain .wait {width: 100%;text-align: center;padding-top: 100px;}.ARMain .wait-mobile {display: none;}*, ::after, ::before {box-sizing: border-box;}.table-row {display: table-row;}.table-cell {display: table-cell;}
        </style>
        </head>
        <body>
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
            <tr><td class="content">${t('LB_BETSLIP_ACCOUNTRECORDS')} - ${t('LB_BS_AR_EXPORT_TITLE')}</td>
            <td align="right">
                <table border="0" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                    <td class="content" style="padding-right:20px;">${getDateText(downloadData.searchParams)}</td>
                    <td class="content" style="padding-right:20px;">${t('LB_BS_LOGIN_ACCOUNT')}: ${sessionStorage.getItem(
                        'account'
                    )}</td>
                    <td class="content">
                    ${t('LB_BS_LOGIN_BALANCE')}: $${textFormatAmountFn(sessionStorage.getItem('balance'))}
                    </td>
                </tr>
                </tbody>
                </table>
            </td>
            </tr>
            </tbody>
            </table>
            ${dlDiv.outerHTML}
            <div> - ${t('LB_BS_AR_EXPORT_END')} - </div>
        </body>
        </html>`;
        let eleLink = document.createElement('a');
        eleLink.download = `acctstmt.html`;
        let blob = new Blob([dlHtml]);
        eleLink.href = URL.createObjectURL(blob);
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);

        sendAdobeEvent({
            event: 'interaction',
            interaction: { download_file_url: eleLink.href }
        });  
    };

    const dateToDateString = (date) => {
        return date
            .toLocaleDateString('zh-HK')
            .split('/')
            .map((i) => {
                if (i.length === 1) return '0' + i;
                return i;
            })
            .join('/');
    };

    const getDateText = (searchParams) => {
        let date;
        switch (searchParams.searchType) {
            case 'today':
                date = `${t('LB_BS_AR_EXPORT_FROM')} ${dateToDateString(offsetDate)} ${t(
                    'LB_BS_AR_EXPORT_TO'
                )} ${dateToDateString(offsetDate)}\r\n`;
                break;
            case 'range':
                date = `${t('LB_BS_AR_EXPORT_FROM')} ${dateToDateString(searchParams.startDate)} ${t(
                    'LB_BS_AR_EXPORT_TO'
                )} ${dateToDateString(searchParams.endDate)}\r\n`;
                break;
            case 'last':
                date = `${t('LB_BS_AR_EXPORT_FROM')} ${dateToDateString(
                    new Date(offsetDate.getTime() - (searchParams.lastDay - 1) * 24 * 60 * 60 * 1000)
                )} ${t('LB_BS_AR_EXPORT_TO')} ${dateToDateString(offsetDate)}\r\n`;
                break;
            default:
                break;
        }
        return date;
    };

    const downloadTEXTFunc = () => {
        const searchParams = downloadData.searchParams;
        const statementData = downloadData.statementData;
        let text = `${t('LB_BETSLIP_ACCOUNTRECORDS')} - ${t('LB_BS_AR_EXPORT_TITLE')}\r\n`;

        const date = getDateText(searchParams);
        const accNo = document.querySelector('.acInfoCell1').innerText + '\r\n';
        const balance = document.querySelector('.acInfoCell2').innerText + '\r\n';
        text = text + date + accNo.split(':').join(': ') + balance.split(':').join(': ');
        text += `${t('LB_BS_AR_TABLE_HEADER_REFNO')}\r\n${t('LB_BS_AR_TABLE_HEADER_DATETIME')}\r\n${t(
            'LB_BS_AR_TABLE_HEADER_RACEDAY'
        )}\r\n${t('LB_BS_AR_TABLE_HEADER_BETTYPE')}\r\n${t('LB_BS_AR_TABLE_HEADER_DETAIL')}\r\n${t(
            'LB_BS_AR_TABLE_HEADER_DEBIT'
        )}\r\n${t('LB_BS_AR_TABLE_HEADER_CREDIT')}\r\n`;
        const lang = i18n.language === 'en' ? 'eng' : 'chi';
        const splitLine = '****************************************\r\n';
        text += splitLine;

        statementData.forEach((item) => {
            const refNo = item.transactionNumber[lang];
            const date = checkDateTimeText(item);
            // let raceDay = '';
            // if (item.payoutType === 'HR') {
            //     const raceDayCode = item.detail?.raw?.split(' ')?.slice(0, 2);
            //     raceDay = t(`LB_${raceDayCode[0]}`) + ' ' + t(`LB_${raceDayCode[1]}_SHORT`);
            // }
            // SQ0248-1816
            let raceDay = ''
            raceDay = item.venueDay[lang];
            const betType = formatBettypeText(item, lang);
            const detail = formatDetailText(item, lang, t);
            const debit = item?.debitAmount?.[lang];
            const credit = item?.creditAmount?.[lang];
            text += `${refNo}\r\n${date}\r\n${raceDay}\r\n${betType}\r\n${detail}\r\n${debit}\r\n${credit}\r\n${splitLine}`;
        });

        text += `- ${t('LB_BS_AR_EXPORT_END')} -`;
        text = stripHtml(text);
        let eleLink = document.createElement('a');
        eleLink.download = `acctstmt.txt`;
        // let blob = new Blob([text]);
        const blob = new Blob(["\ufeff",text], {type: 'text/plain;charset=utf-8'}); // 防止乱码
        eleLink.href = URL.createObjectURL(blob);
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);

        sendAdobeEvent({
            event: 'interaction',
            interaction: { download_file_url: eleLink.href }
        });
    };

    const stripHtml = (text) => {
        var newText;
        newText = text.replaceAll('<br>', '\r\n');
        newText = newText.replaceAll('&nbsp;', ' ');
        return newText;
    };

    const title = (
        <div className="df ARExportBtn" title={t('LB_BS_AR_EXPORT_MSG1')}>
            <div className="icon-download-white"></div>
            {t('LB_BS_AR_EXPORT')}
        </div>
    );

    return (
        <div>
            <DropdownButton
                as={ButtonGroup}
                key={`DropdownButton-arexport`}
                id={`dropdown-variants-arexport`}
                variant={'arexport'}
                title={title}
            >
                <Dropdown.Item onClick={downloadHTMLFunc} value={'HTML'} key="HTML">
                    <div>{t('LB_BS_AR_EXPORT_HTML')}</div>
                </Dropdown.Item>
                <Dropdown.Item onClick={downloadTEXTFunc} value={'TEXT'} key="TEXT">
                    <div>{t('LB_BS_AR_EXPORT_TEXT')}</div>
                </Dropdown.Item>
            </DropdownButton>
        </div>
    );
};
export const Print = ({ currentTab, printRef }) => {
    const { t } = useTranslation();

    const printContent = () => {
        const acInfoDom = document.querySelector('.acInfo');
        const cloneAcInfoDom = acInfoDom.cloneNode(true);
        const printDom = document.querySelector('.ARMain');
        const clonePrintDom = printDom.cloneNode(true);
        const ARInbox = document.createElement('div');
        ARInbox.className = 'ARInbox ARPrintContent';
        ARInbox.appendChild(cloneAcInfoDom);
        ARInbox.appendChild(clonePrintDom);
        return ARInbox;
    };

    const onBeforePrint = () => {};

    const title = t('LB_BS_AR_PRINT_MSG1');
    const reactToPrintFn = useReactToPrint({
        contentRef: printRef,
        bodyClass: "ARPrintContent",
        documentTitle: document.title,
        pageStyle:'size: A4; margin: 15mm;',
        preserveAfterPrint: true,
     });

    return (
        // <ReactToPrint
        //     trigger={() => (
                
        //     )}
        //     bodyClass="ARPrintContent"
        //     documentTitle={document.title}
        //     onBeforePrint={onBeforePrint}
        //     pageStyle={'size: A4; margin: 15mm;'}
        //     content={printContent}
        // />
        <a onClick={reactToPrintFn} className="df ARPrintBtn" title={title}>
                    <div className="icon-print-white"></div>
                    {t('LB_PRINT')}
                </a>
    );
};
